import {calcPercentage} from 'helpers/common-helper';

export class PlayerLineupsUsage {
    private readonly percentage: number;
    constructor(
        private readonly playerUsedInLineupsQuantity: number = 0,
        readonly totalLineupsQuantity: number = 0,
    ) {
        this.percentage = calcPercentage(totalLineupsQuantity, playerUsedInLineupsQuantity, 0);
    }
    getPercentage(): number {
        return this.percentage;
    }
    getQuantity(): number {
        return this.playerUsedInLineupsQuantity;
    }
    combineUsage(usage: PlayerLineupsUsage): PlayerLineupsUsage {
        return new PlayerLineupsUsage(
            this.playerUsedInLineupsQuantity + usage.playerUsedInLineupsQuantity,
            this.totalLineupsQuantity,
        );
    }
}
